import {FormattedMessage} from 'react-intl';
import Utils from '../Common/Utils.js';


//Function to split data 
const splitScaleData = (data) => {
    
    var splitted_scale_Data = data.split("W");
    var splitted_Data =  Number.parseFloat([splitted_scale_Data[1]])/1000

    return (splitted_Data.toFixed(1));

}



const formatAndMergeScaleData = (fullLoad, oldScaleData, newScaleData) => {

    let local_data = {'weight': []};
    let isANewDateValue = "";

    // Reset data if new load
    if (fullLoad){
        oldScaleData = []
    }

    if (oldScaleData !== undefined){
        Utils.mergeBasicOldData(oldScaleData, local_data.weight)
                }                                          

    if (newScaleData !== undefined){
        if(newScaleData.length !== 0){
            let splittedData;
            for (var i = newScaleData.length-1; i >= 0; i--){        // Find new values and add it  
                isANewDateValue = local_data.weight.find(xDate => { return xDate.x === new Date(newScaleData[i].eventDate).getTime() })
                if(isANewDateValue === undefined){                 
                    splittedData = splitScaleData(newScaleData[i].value); // separate Type and weight
                        local_data.weight.push(  {x: new Date(newScaleData[i].eventDate).getTime(), y: splittedData});
                }
            }
        }
    }
    return local_data;
}


//Function to get lastscale data
const getLastWeightDataAndColor = (dataset, threshold, threshold2) => {

    let scaleData = {
        weight: "-",
        color: "#767676"
    };

    if((dataset !== undefined)&&(dataset.length > 0)){
        //set scale value
        scaleData.weight = dataset[dataset.length-1].y
        //Set scale color
        if (threshold2 === null || threshold2 === undefined) {
            threshold2 = Utils.setDefaultThreshold2("scale")
        }
        scaleData.color = Utils.setMeasureColor(dataset[dataset.length-1].y, threshold, 10, "sup", threshold2);
    }
    return (scaleData);
}

//Const to import functions in other files
const ScaleManager = {
  getLastWeightDataAndColor,
  formatAndMergeScaleData
};

export default ScaleManager;